/**
 * "le 1er mois, puis €29/mois" — what a time-limited promotion code costs once
 * it runs out. `months` comes from the code validation (`discountMonths`).
 */
export const promoThenPrice = (t, months, price) => (months === 1
  ? t('billing.promo_first_month_then', { price })
  : t('billing.promo_months_then', { count: months, price }));
